import {ErrorMessage, Field, Form, Formik} from "formik";
import postData from "../services/postData";
import Modal from "./Modal";
import {useState} from "react";
import {ScrollToFieldError} from "./formik/ScrollToFieldError";
import {formSchema} from "../schema/formSchema";
import SkodaDataInfo from "./SkodaDataInfo";

export default function ServiceForm({setLoadingSpinnerOpen}) {

    const formType = 'exit,popup,bp';

    const [successModal, setSuccessModal] = useState(false);
    const [failureModal, setFailureModal] = useState(false);
    const [formIsSubmitting, setFormIsSubmitting] = useState(false);

    const dataLayerPush = (orderId) => {
        try {
            window.dataLayer.push({
                'event': 'formularze',
                'wypelniony-formularz': 'newsletter-zamowiono',
                'orderid': orderId
            });
            console.log('dataLayer.push ok:', orderId);
        } catch (err) {
            console.error('dataLayer.push error:', err);
        }
    };

    const syneriseSendFormData = (orderId, values) => {
        if (!('SR' in window)) {
            console.error('SR undefined');
            return;
        }

        const snrData = {
            orderID: orderId,
            name: values.name,
            phone: values.phone
        };
        try {
            window.SR.event.sendFormData(formType, snrData)
                .then((res) => {
                    console.log(formType);
                    console.log(res);
                })
                .catch((err) => {
                    console.log(formType);
                    console.error(err);
                });
        } catch (err) {
            console.error('SR error', err);
        }
    };

    return (
        <Formik
            initialValues={{
                name: '',
                phone: '',
            }}
            validationSchema={formSchema}
            onSubmit={(values, actions) => {
                actions.setSubmitting(false);
                setFormIsSubmitting(true);

                values['formType'] = formType;

                postData(values)
                    .then((data) => {
                        if (data && data.status === 'ok') {

                            dataLayerPush(data.orderId);
                            syneriseSendFormData(data.orderId, values);
                            actions.resetForm();
                            setSuccessModal(true);
                        } else {
                            setFailureModal(true);
                        }
                    })
                    .catch((error) => {
                        setFailureModal(true);
                    })
                    .finally(() => {
                        setFormIsSubmitting(false);
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth"
                        });
                    });
            }}
        >
            {(formikProps) => (
                <>
                    <Modal open={successModal} setOpen={setSuccessModal}>
                        <b>Dziękujemy za wypełnienie formularza.</b>
                    </Modal>

                    <Modal open={failureModal} setOpen={setFailureModal}>
                        Wystąpił błąd!<br/>
                        Prosimy spróbować później.
                    </Modal>

                    <Form className="form-container form-container js-subscribe-form" method={`post`}>
                        <ScrollToFieldError/>

                        <div className="desktop-columns">
                            <div className="form-row">
                                <div className="form-copy">
                                    <b><h2>Potrzebujesz więcej informacji?</h2></b>
                                    <p>
                                        Zostaw swój numer telefonu, a my oddzwonimy,
                                        by&nbsp;odpowiedzieć na&nbsp;wszystkie Twoje pytania
                                        dotyczące&nbsp;interesującego Cię modelu.
                                    </p>
                                </div>
                            </div>

                            <div className="form-row form-row--inline js-form-item-firstname">
                                <label className="form-label" htmlFor="name"
                                    style={{
                                        color: 'white',
                                        fontSize: '15px',
                                        fontWeight: '700'
                                    }}
                                >Imię</label>
                                <Field id="name"
                                    style={{
                                        border: '2px solid gray',
                                        fontSize: '15px',
                                        color: 'white'
                                    }}
                                    name="name" type="text" className="form-input" maxLength={9} placeholder="Podaj imię"></Field>
                                <label className="form-label" htmlFor="phone"
                                    style={{
                                        color: 'white',
                                        fontSize: '15px',
                                        fontWeight: '700',
                                        marginTop: '10px'
                                    }}
                                >Numer telefonu*</label>
                                <Field id="phone"
                                    style={{
                                        border: '2px solid gray',
                                        fontSize: '15px',
                                        color: 'white'
                                    }}
                                    name="phone" type="tel" className="form-input" maxLength={9} placeholder="Wpisz numer 9-cio cyfrowy"></Field>
                                <ErrorMessage name="phone">{msg => <div className="form-error">{msg}</div>}</ErrorMessage>
                            </div>
                        </div>
                        
                        <div style={{
                            margin: '30px 0 40px'
                        }}>
                            <SkodaDataInfo/>
                        </div>
                        <br/>
                        <div className="form-row form-row--buttons">
                            <button type="submit" className="button button--primary" disabled={formIsSubmitting}>
                                Chcę porozmawiać
                            </button>
                        </div>
                    </Form>
                </>
            )}
        </Formik>
    );
}
